"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// Open/Close
// Animate side to side
// import debounce from '../../utilities/debounce';
var debounce_1 = __importDefault(require("../../utilities/debounce"));
exports.default = (function (target, breakupMobile) {
    var windowWidth = window.innerWidth;
    var mobileBreakpoint = breakupMobile ? 960 : 0;
    var getItemHeight = function (item) {
        item.style.transition = 'none';
        item.style.height = 'auto';
        var itemHeight = item.clientHeight;
        item.style.height = '';
        item.style.transition = '';
        return itemHeight;
    };
    var updateContainerHeight = function (group, item) {
        var container = group.querySelector('.GroupedContent__container'), newHeight = (window.innerWidth > mobileBreakpoint) ? item.clientHeight + 'px' : '';
        if (container) {
            container.style.height = newHeight;
            return true;
        }
        return false;
    };
    var registerAccordionEvents = function (group, item) {
        var singleActive = item.querySelector('.GroupedContent__item');
        if (!singleActive) {
            return;
        }
        var singleActiveContent = singleActive.querySelector('.GroupedContent__item__content');
        if (!singleActiveContent) {
            return;
        }
        // Not sure if this is needed: TODO, evaluate
        var itemHeightFn = function (content) {
            var height = getItemHeight(content);
            window.addEventListener('resize', debounce_1.default(function () {
                if (windowWidth === window.innerWidth)
                    return;
                height = getItemHeight(content);
                return height;
            }, 250));
            return function () { return (height); };
        };
        var itemHeight = itemHeightFn(singleActiveContent);
        var clickEvent = function () {
            if (singleActive.classList.contains('is-active')) {
                // Close
                singleActive.classList.remove('is-active');
                singleActiveContent.classList.remove('is-active');
                singleActiveContent.style.height = '';
            }
            else {
                // Open
                singleActive.classList.add('is-active');
                singleActiveContent.style.height = itemHeight() + 'px';
            }
        };
        item.addEventListener('click', function (e) {
            e.preventDefault();
            return clickEvent();
        });
    };
    var directionalAnimationClass = function (item, previousItem) {
        var itemLeft = item.getBoundingClientRect().left;
        var prevLeft = previousItem.getBoundingClientRect().left;
        return itemLeft > prevLeft ? 'animateLeft' : 'animateRight';
    };
    var activeBar = document.querySelector('.GroupedContent__activeBar');
    var positionActiveBar = function (item) {
        var width = item.getBoundingClientRect().width;
        var left = item.offsetLeft;
        activeBar.style.width = width + 'px';
        activeBar.style.left = left + 'px';
    };
    var registerTabEvents = function (group, item) {
        var content = Array.from(group.querySelectorAll('.GroupedContent__item'));
        var tabNav = Array.from(group.querySelectorAll('.GroupedContent__nav > *'));
        var singleActive = group.querySelector('.GroupedContent__item[data-content="' + item.dataset.content + '"]');
        if (!singleActive)
            return;
        item.addEventListener('click', function (e) {
            e.preventDefault();
            var previousItem = group.querySelector('.GroupedContent__item.is-active');
            // Remove class from active item/nav item
            content.forEach(function (item) { return item.classList.remove('is-active'); });
            tabNav.forEach(function (item) { return item.classList.remove('is-active'); });
            // Add active class to nav item
            item.classList.add('is-active');
            if (previousItem)
                item.classList.add(directionalAnimationClass(item, previousItem));
            positionActiveBar(item);
            singleActive.classList.add('is-active');
            return updateContainerHeight(group, singleActive);
        });
    };
    var initGroupContent = function (group) {
        var tabNav = Array.from(group.querySelectorAll('.GroupedContent__nav > *'));
        var accordionNav = Array.from(group.querySelectorAll('.GroupedContent__item__title'));
        var content = Array.from(group.querySelectorAll('.GroupedContent__item'));
        if (!tabNav || !accordionNav || !content)
            return;
        // This is fine for both tabs and accordions
        // it isn't beautiful, but not something I'll fix at this moment
        var firstItem = group.querySelector('.GroupedContent__item[data-content="' + tabNav[0].dataset.content + '"]');
        var firstNavItem = group.querySelector('.GroupedContent__nav__item.is-active');
        if (!firstItem)
            return;
        window.addEventListener('resize', debounce_1.default(function () {
            var activeItem = group.querySelector('.GroupedContent__item.is-active');
            updateContainerHeight(group, activeItem);
            if (window.innerWidth < (mobileBreakpoint + 1)) {
                content.forEach(function (item) { return item.classList.remove('is-active'); });
            }
        }, 250, true));
        tabNav.forEach(function (item) { return registerTabEvents(group, item); });
        accordionNav.forEach(function (item) { return registerAccordionEvents(group, item); });
        updateContainerHeight(group, firstItem);
        positionActiveBar(firstNavItem);
        if (window.innerWidth < (mobileBreakpoint + 1)) {
            content.forEach(function (item) { return item.classList.remove('is-active'); });
        }
        return group;
    };
    var _target;
    if (typeof target === 'string') {
        var _node = Array.from(document.querySelectorAll(target));
        if (_node) {
            _target = _node;
        }
    }
    else {
        _target = target;
    }
    if (_target) {
        return _target.forEach(initGroupContent);
    }
    else {
        return false;
    }
});
